import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Tax } from '@app/shared/models/tax';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-add-tax-type',
  templateUrl: './add-tax-type.component.html',
  styleUrls: ['./add-tax-type.component.scss'],
})
export class AddTaxTypeComponent implements OnInit {
  tax: Tax = null;
  @Input() tax$: Observable<Tax>;
  @Output() complete: EventEmitter<string> = new EventEmitter();

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.tax$.subscribe((tax) => {
      this.tax = tax;
    });
  }

  progress() {
    if (this.tax.charge_type === 'percent') {
      this.complete.emit('setup');
    } else if (this.tax.charge_type === 'fixed') {
      this.complete.emit('calculation');
    }
  }

  back() {
    this.complete.emit('id');
  }
}
